// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"ImageBlock_imageBlock__1LT0o","headingColumn":"ImageBlock_headingColumn__34Jr4","imageColumn":"ImageBlock_imageColumn__3qyYe"};